import { createRequestTypes } from '@alycecom/utils';

export const LOAD_CAMPAIGN_SWAG_INVITES_SETTINGS = createRequestTypes('LOAD_CAMPAIGN_SWAG_INVITES_SETTINGS');
export const UPDATE_SWAG_CAMPAIGN_BUDGET_SETTINGS = createRequestTypes('UPDATE_SWAG_CAMPAIGN_BUDGET_SETTINGS');
export const UPDATE_SWAG_CAMPAIGN_REQUIRED_ACTIONS_SETTINGS = createRequestTypes(
  'UPDATE_SWAG_CAMPAIGN_REQUIRED_ACTIONS_SETTINGS',
);
export const LOAD_SWAG_CAMPAIGN_PRODUCT_TYPES = createRequestTypes('LOAD_SWAG_CAMPAIGN_PRODUCT_TYPES');
export const UPDATE_SWAG_CAMPAIGN_PRODUCT_TYPES = createRequestTypes('UPDATE_SWAG_CAMPAIGN_PRODUCT_TYPES');
